import React from "react";
import { PaystackButton } from "react-paystack";
import RouteApi from "../Backend/Backend";

const PaystackPayment = ({ email, amount, name, onSuccess, onClose }) => {
    const publicKey = "pk_test_7a5b455e902bbb9f1f045df9f22158e6064ad4d4"; // Replace with your actual Paystack public key
    const { storePayment } = RouteApi();

    const componentProps = {
        email,
        amount: amount * 100, // Paystack expects amount in kobo
        metadata: { name },
        publicKey,
        text: "Pay Now",
        onSuccess: async (response) => {
            console.log("✅ Paystack payment successful:", response);

            // ✅ Store the payment in your backend
            const result = await storePayment({
                email,
                amount,
                reference: response.reference,
            });

            console.log("Backend store result:", result);

            if (onSuccess) onSuccess(response);
        },
        onClose: () => {
            console.log("❌ Payment closed");
            if (onClose) onClose();
        },
    };

    return (
        <div>
            <PaystackButton
                {...componentProps}
                className="btn btn-success btn-lg text-white px-8 py-2 rounded-pill"
                disabled={amount ? false : true}
            />
        </div>
    );
};

export default PaystackPayment;
